
import React, { memo, type ReactNode } from "react";
import { ItemSlot } from "./ItemSlot";
import { type ItemRowType } from "../types";

const ItemRowWrapper = ({ children, className = "", textColor = "cui-text-fg-default", ...rest }: { children: ReactNode, className?: string, textColor?: string }) => {
  return (
    <div className={`cui-w-auto cui-flex cui-items-center cui-justify-between cui-gap-xs ${textColor} ${className}`} {...rest}>
      {children}
    </div>
  );
};

export const ItemRow = memo(
  ({
    leadingStart,
    leadingEnd,
    trailingStart,
    trailingEnd,
    children,
    className,
    textColor,
    type,
    ...rest
  }: ItemRowType) => {
    return (
      <ItemRowWrapper className={className} textColor={textColor} {...rest}>
        <ItemSlot slot={leadingStart} />
        <ItemSlot slot={leadingEnd} />
        {!!children ? (
          <ItemSlot slot={children} className="cui-flex-grow" textColor={textColor} />
        ) : (
          <div className="cui-flex-grow" />
        )}
        <ItemSlot slot={trailingStart} />
        <ItemSlot slot={trailingEnd} />
      </ItemRowWrapper>
    );
  }
);

ItemRow.displayName = "ItemRow";
